export interface RunnerStageAssets {
  backgroundVideoUrl: string;
  obstacleJumpUrl: string;
  obstacleDuckUrl: string;
  obstaclePunchUrl: string;
  obstacleDodgeUrl: string;
  obstaclePunchDestroyedUrl: string;
}

export const almatyStage: RunnerStageAssets = {
  backgroundVideoUrl: 'https://1t.gg/storage/groover-media/media/1780394796550-runner_almaty_bg.mp4',
  obstacleJumpUrl: 'https://1t.gg/storage/groover-media/media/1780394865846-img_low_wall.png',
  obstacleDuckUrl: 'https://1t.gg/storage/groover-media/media/1780394886881-img_overhang.png',
  obstaclePunchUrl: 'https://1t.gg/storage/groover-media/media/1780394899690-img_boxes_small.png',
  obstacleDodgeUrl: 'https://1t.gg/storage/groover-media/media/1780394926471-img_hydrant.png',
  obstaclePunchDestroyedUrl: 'https://1t.gg/storage/groover-media/media/1780394942981-confetti.png',
};
